<template>
  <div id="app">
    <div class="p-grid">
      <div class="p-col">
        <Panel header="Preview"><div v-html="html"></div></Panel>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col">
        <Editor v-model="html" editorStyle="height: 500px" />
      </div>
    </div>
  </div>
</template>

<script>
import Editor from "primevue/editor";
import Panel from "primevue/panel";

export default {
  name: "app",
  computed: {
    html: {
      get() {
        return this.$store.state.html;
      },
      set(value) {
        this.$store.commit("updateHTML", value);
      }
    }
  },
  components: {
    Editor,
    Panel
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
